<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="/img/brand/logo.svg" width="89" height="25" alt="Logo">
        <img class="navbar-brand-minimized" src="/img/brand/sygnet.svg" width="30" height="30" alt="Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <!-- <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item> -->
      </b-navbar-nav>
      <ProjectDropdown class="navbar-nav" />
      <b-navbar-nav class="ml-auto">
        <LanguagesDropdown type="b-nav-item-dropdown"/>
        <NotificationsDropdown/>
<!--
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>

        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item> -->

        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" :key="index" v-for="(route, index) in routeRecords">
            <span class="active" v-if="index === routeRecords.length - 1">{{ title || route.label }}</span>
            <router-link v-else :to="{ name: route.name, params: route.to.params}">{{ route.label }}</router-link>
          </li>
        </ol>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed>
        <DefaultAside/>
      </AppAside> -->
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        By <a href="https://applyit.lv">Apply SIA</a>
        <span class="ml-1">&copy; 2021 Dataset server</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import {
  Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader,
  SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter
} from '@coreui/vue';
import { mapGetters, mapState } from 'vuex';
import cloneDeep from 'lodash.clonedeep';
import Vue from 'vue';
import DefaultAside from '@/containers/DefaultAside';
import DefaultHeaderDropdownAccnt from '@/containers/DefaultHeaderDropdownAccnt';
import NotificationsDropdown from '@/containers/Dropdowns/NotificationsDropdown';
import ProjectDropdown from '@/views/Projects/ProjectDropdown';
import LanguagesDropdown from '@/containers/Dropdowns/LanguagesDropdown';
import _nav from '@/_nav';

export default {
  name: 'DefaultContainer',
  beforeMount() {
    if (!this.token) {
      this.$router.push({ name: 'Login' });
    }
    this.refreshNav();
  },
  mounted() {
    this.$root.$on('current-title', ({ title }) => {
      this.title = title;
    });
  },
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NotificationsDropdown,
    LanguagesDropdown,
    ProjectDropdown
  },
  data() {
    return {
      title: false,
    };
  },
  computed: {
    ...mapGetters('Auth', [
      'token', 'user', 'projects', 'activeProject'
    ]),
    ...mapState('Auth', [
      'activeProjectId'
    ]),
    name() {
      return this.$route.name;
    },
    routeRecords() {
      return this.$route.matched.filter((route) => route.name || route.meta.label).map((route) => {
        return {
          label: this.$t(route.meta.label),
          to: route.path,
          name: route.name,
          params: this.$route.params
        };
      });
    },
    nav: {
      get() {
        return JSON.parse(JSON.stringify(_nav(this.activeProjectId))).items.filter(
          (item) => this.navItemAvailable(item)
        ).map((item) => this.navItemMap(item));
      },
      set(nevNav) {
        return nevNav;
      }
    },
    ...mapState('Auth', ['activeProjectId']),
  },
  watch: {
    activeProjectId() {
      if (this.$route.name !== 'Dashboard' && this.activeProjectId) this.$router.push({ name: 'Dashboard' });
      this.refreshNav();
    },
    $route(to, from) {
      this.title = false;
    },
    // '$i18n.locale'() { this.refreshNav(); }
  },
  methods: {
    refreshNav() {
      this.nav = Vue.observable(_nav().items
        .filter((item) => this.navItemAvailable(item))
        .map(((item) => cloneDeep(item)))).map((item) => this.navItemMap(item));
      this.nav = JSON.parse(JSON.stringify(_nav())).items.filter(
        (item) => this.navItemAvailable(item)
      ).map((item) => this.navItemMap(item));
    },
    navItemAvailable(item) {
      return item.canSee !== false;
    },
    navItemMap(item) {
      item.children = !item.children ? undefined : item.children.filter(
        (child) => this.navItemAvailable(child)
      ).map(
        (child) => this.navItemMap(child)
      );
      Vue.set(item, 'name', this.$t(item.name));
      // item.attributes = { disabled: item.disableOffline && this.isOffline }; // modify when offline
      return item;
    }
  },
};
</script>
